import type { NpsQuestion } from '@/shared/types/nps';
import { contactFieldKind, maskPhone, partitionSurveyQuestions } from '@/features/nps/public-survey/partition-questions';
import { maskCpf, type AnswerValue } from '@/features/nps/public-survey/public-survey-question-field';
import type { ParticipantProfile } from '../api/participant-api';

/** `dd/mm/aaaa` (legado) → `aaaa-mm-dd` (DatePicker da pesquisa). */
function birthdayIso(value: string): string | null {
  const br = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (br) return `${br[3]}-${br[2]}-${br[1]}`;
  return /^\d{4}-\d{2}-\d{2}$/.test(value) ? value : null;
}

/**
 * Quem está logado já tem os dados no cadastro: a pesquisa chega preenchida.
 *
 * - Bloco de dados pessoais (perguntas de texto no começo da pesquisa, o mesmo
 *   corte do `partitionSurveyQuestions`): nome, e-mail, celular e CPF pelo
 *   título da pergunta.
 * - Pergunta de data com "nascimento"/"aniversário" no título: a data do cadastro.
 *
 * Perguntas de opinião nunca são preenchidas.
 */
export function surveyPrefill(
  questions: NpsQuestion[],
  profile: ParticipantProfile,
  uniqueId: string,
): Record<string, AnswerValue> {
  const out: Record<string, AnswerValue> = {};
  const { userInfo } = partitionSurveyQuestions(questions);
  const contactIds = new Set(userInfo.map((q) => q.id));

  for (const q of questions) {
    const title = q.title.toLowerCase();
    if (contactIds.has(q.id)) {
      const kind = contactFieldKind(q.title);
      if (kind === 'email' && profile.email) out[q.id] = profile.email;
      else if (kind === 'phone' && profile.phone) out[q.id] = maskPhone(profile.phone);
      else if (/\bcpf\b|documento/.test(title) && uniqueId.length === 11) out[q.id] = maskCpf(uniqueId);
      else if (kind === 'name' && profile.name) out[q.id] = profile.name;
    } else if (q.response_type === 'DATE' && /nascimento|anivers/.test(title)) {
      const iso = birthdayIso(profile.birthday);
      if (iso) out[q.id] = iso;
    }
  }
  return out;
}
